<template>
  <div>
    <list
      row-key="EduToHomeId"
      ref="list"
      unit="校讯通设置"
      :page="page"
      :show-checkbox="$permission.canWrite()"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
      :selectable="(x)=>{return x.StuCount == 0}"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="启用学校">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option
              v-for="(i,key) in schools"
              :key="key"
              :value="i.SchoolId"
              :label="i.SchoolName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select size="mini" v-model="params.Status" clearable>
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SchoolName" label="启用学校" min-width="140px" show-overflow-tooltip />
        <el-table-column prop="MonthCharge" label="月收费" />
        <el-table-column prop="Amount" label="收费周期" min-width="140px">
          <template slot-scope="{row}">
            <span>{{row.StartMonth}}</span>
            <span style="margin: 5px;">~</span>
            <span>{{row.EndMonth}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="MonthCountLimit" label="每月通话次数上限" min-width="120px" />
        <el-table-column prop="SingleDurationLimit" label="每次通话时长上限" min-width="120px" />
        <el-table-column prop="Status" label="状态" align="center" width="70">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status==1">启用</el-tag>
            <el-tag type="danger" v-if="row.Status==0">停用</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/consume/edutohome").default,
      school_api: require("@/api/st/school").default,
      params: {
        SchoolId: null,
        Status: null,
      },
      schools: [],
    };
  },
  beforeMount() {
    this.school_api.list({ Status: 1 }).then((res) => {
      if (res.Code == 0) this.schools = res.Data;
    });
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>